// Clé pour le stockage localStorage des colonnes visibles
export const SENSOR_LIST_COLUMNS_STORAGE_KEY = 'sensorlist_visible_columns'

// Colonnes visibles par défaut
export const DEFAULT_VISIBLE_COLUMNS = [
  'photo',
  'label', 
  'macAddr',
  'actif',
  'latestValues',
  'temperature',
  'humidity',
  'battery',
  'lastSeen'
]

export const ALL_COLUMNS = [
  {
    key: 'photo',
    label: 'Photo'
  },
  {
    key: 'label',
    label: 'Nom du Capteur'
  },
  {
    key: 'macAddr',
    label: 'Adresse MAC'
  },
  {
    key: 'actif',
    label: 'Statut'
  },
  {
    key: 'latestValues',
    label: 'Dernières Valeurs'
  },
  {
    key: 'temperature',
    label: 'Température'
  },
  {
    key: 'humidity',
    label: 'Humidité'
  },
  {
    key: 'battery',
    label: 'Batterie'
  },
  {
    key: 'lastSeen',
    label: 'Dernière activité'
  },
  // {
  //   key: 'alerte',
  //   label: 'Alerte'
  // },
]

export const GROUP_BY_OPTIONS = [
  { field: 'type', label: 'Par Type' },
  { field: 'status', label: 'Par Statut' },
  { field: 'location', label: 'Par Emplacement' },
  { field: 'batteryLevel', label: 'Par Niveau de Batterie' }
]
